ready(function(){
	const map = document.getElementById('map');
	if (map) {

		// -- switch view --
		const switchViewCheckbox = document.getElementById('switchView');
		const mapViewElement = document.querySelector('.mapView');
		const listViewElement = document.querySelector('.listView');
		switchViewCheckbox.addEventListener('change', function() {
			if (switchViewCheckbox.checked) {
				mapViewElement.classList.add('hidden');
				listViewElement.classList.remove('hidden');
			} else {
				mapViewElement.classList.remove('hidden');
				listViewElement.classList.add('hidden');
			}
		});


		// -- list view : on change --

		// -- variables --
		const activitySelect = document.getElementById('activity');
		const audienceSelect = document.getElementById('audience');
		const btnCatsEl = document.querySelectorAll('.btn--cats');
		const btnResetEl = document.querySelector('.btn--reset');
		const resultEl = document.querySelector('.result');
		const resultTotalEl = resultEl.querySelector('.total');
		const resultActivityEl = resultEl.querySelector('.activity');
		const resultAudienceEl = resultEl.querySelector('.audience');

		// -- listen event --
		activitySelect.addEventListener('change', handleInputChange);
		audienceSelect.addEventListener('change', handleInputChange);

		// -- handle input change action --
		function handleInputChange(e) {
			e.preventDefault();
			resetNotification();
			const form = this.parentElement;
			var formData = new FormData(form);
			var xhr = new XMLHttpRequest();
			xhr.open("POST", "", true);
			xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
			xhr.onload = function() {
				if (xhr.status >= 200 && xhr.status < 300) {
					// Successful response
					var response = JSON.parse(xhr.responseText);
					if (response.success) {
						var entryIds = response.entriesIds;
						// console.log(entryIds);
						btnCatsEl.forEach(function(btn) {
							// -- reset status --
							btn.classList.remove('disabled');
							// -- find matching ids --
							var hasMatchingId = entryIds.some(function(entryId) {
							  return btn.classList.contains('entryId--' + entryId);
							});
							// -- apply status --
							if (!hasMatchingId) {
							  btn.classList.add('disabled');
							}
						});
						// -- result notification --
						handleResultNotification(response);					
					} else {
						console.error('Request was not successful');
						window.location.reload();
					}
				} else {
					console.error(xhr.statusText);
					window.location.reload();
				}
			};
			xhr.send(new URLSearchParams(formData));
		}

		// -- handle result notification --
		function handleResultNotification(response) {
			resultEl.classList.remove('hidden');
			resultTotalEl.textContent = response.total;
			resultActivityEl.textContent = activitySelect.options[activitySelect.selectedIndex].textContent;
			resultAudienceEl.textContent = audienceSelect.options[audienceSelect.selectedIndex].textContent;
		}

		// -- handle reset button --
		btnResetEl.addEventListener('click', function() {
			resetNotification();
		});


		// -- reset notification --
		function resetNotification(){
			resultEl.classList.add('hidden');
			btnCatsEl.forEach(function(btn) {
				btn.classList.remove('disabled');
			});
		}

	}
});